import {
  ScreenshotRecommendationHistoryDto,
  ScreenshotRecommendationType,
  WebsocketScreenshotRecommendationProgress,
} from "@intelligems/ig-types";

import { initialAiState } from "../slices/ai";
import { AiScreenshotRecommendationFe } from "../types/ai";

export type ScreenshotRecommendationReducerAction =
  | {
      type: "setFinalUrl";
      value: string;
    }
  | {
      type: "setPendingUrl";
      value: string;
    }
  | {
      type: "setIsCustomUrl";
      value: boolean;
    }
  | {
      type: "setScreenshotUrl";
      value: string;
    }
  | {
      type: "setRecommendations";
      value: ScreenshotRecommendationType[];
    }
  | {
      type: "setRecommendationHistory";
      value: ScreenshotRecommendationHistoryDto[];
    }
  | {
      type: "setStep";
      value: WebsocketScreenshotRecommendationProgress["action"];
    }
  | {
      type: "setShowLatest";
      value: boolean;
    }
  | {
      type: "setResultIndex";
      value: number;
    }
  | { type: "decrementResultIndex" }
  | { type: "incrementResultIndex" }
  | { type: "reset" };

export function ScreenshotRecommendationReducer(
  draft: AiScreenshotRecommendationFe,
  action: ScreenshotRecommendationReducerAction
) {
  switch (action.type) {
    case "reset":
      draft = initialAiState.screenshotRecommendations;
      return draft;
    case "setPendingUrl":
      draft.pendingUrl = action.value;
      return draft;
    case "setFinalUrl":
      draft.finalUrl = action.value;
      draft.showLatest = true;
      return draft;
    case "setIsCustomUrl":
      draft.isCustomUrl = action.value;
      return draft;
    case "setStep":
      if (action.value === "start") {
        draft.latestRecommendations = [];
        draft.screenshotUrl = null;
      }
      draft.step = action.value;
      return draft;
    case "setScreenshotUrl":
      draft.screenshotUrl = action.value;
      return draft;
    case "setRecommendationHistory":
      draft.recommendationHistory = action.value.filter(
        (i) =>
          JSON.stringify(i.recommendations[0]?.recommendation || "{}") !==
          JSON.stringify(draft.latestRecommendations[0]?.recommendation || "{}")
      );
      return draft;
    case "setRecommendations":
      draft.latestRecommendations = action.value;
      return draft;
    case "setShowLatest":
      draft.showLatest = action.value;
      return draft;
    case "setResultIndex":
      draft.resultIndex = action.value;
      return draft;
    case "decrementResultIndex":
      draft.resultIndex -= 1;
      return draft;
    case "incrementResultIndex":
      draft.resultIndex += 1;
      return draft;
    default:
      return draft;
  }
}
